/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_Broker_PairedInputs */

const cs_ebr_pairing_broker_paired = /** @type {(inputs: Ebr_Pairing_Broker_PairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`makléř spárován`)
};

const en_ebr_pairing_broker_paired = /** @type {(inputs: Ebr_Pairing_Broker_PairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`broker paired`)
};

/**
* | output |
* | --- |
* | "broker paired" |
*
* @param {Ebr_Pairing_Broker_PairedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_broker_paired = /** @type {((inputs?: Ebr_Pairing_Broker_PairedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_Broker_PairedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_broker_paired(inputs)
	return cs_ebr_pairing_broker_paired(inputs)
});